import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Introduction from "../components/Introduction/Introduction"
import Process from '../components/Process/Process'

const BlogIndex = ({ location }) => {

  return (
    <Layout location={location}>
      <SEO title="Spin　D&D" />
      <Introduction />
      <Process />
    </Layout>
  )
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          date(formatString: "MMMM DD, YYYY")
          title
          description
        }
      }
    }
  }
`
